module.exports = __webpack_public_path__ + "img/170220.92b537e8.png";